import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import MyHeader from './maincomponent/Myheader';
import MyFooter from './maincomponent/Myfooter';


function App() {
  return (
    <Router>
      <MyHeader />
      {/* Add a footer component if needed */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <MyFooter/>
    </Router>
  );
}

export default App;
